<div class="info-box">
  <mat-icon>info</mat-icon>

  <div>
    <ng-content></ng-content>
  </div>
</div>
